import { Link, useSearchParams } from 'react-router-dom'

import Button from 'components/Button'
import { useReport13Query } from '../../../reports-list/reports-form-list/create-report_13/use-report-#-13'
import { ExportToCSV } from '../../../reports-list/utils-reports-actions'
import { Report13Table } from './table'

export const ViewReport13 = () => {
  const [searchParams] = useSearchParams()
  const searchQuery = JSON.parse(
    decodeURIComponent(searchParams.get('report-query')!)
  )
  const {
    data: report13Data,
    isLoading,
    isSuccess,
  } = useReport13Query(searchQuery)

  if (isLoading) return <div></div>
  if (isSuccess && !report13Data) return <div></div>

  return (
    <div className="my-6">
      <div className="flex items-center gap-4">
        <button
          className="px-3 py-1 border rounded-md border-primary text-primary"
          type="button"
        >
          <Link
            to={`/reports-list?modal=report_13`}
            className="flex items-center gap-2"
          >
            {/* <CreateIcon size={16} /> */}
            <span className="tracking-wider font-light">Back to reports</span>
          </Link>
        </button>

        <Button
          type="button"
          // icon={faDownload}
          className="ml-1 rounded-lg tracking-wide font-bold"
          iconRight={false}
          onClick={() =>
            ExportToCSV(report13Data?.data || [], { filename: 'Report-13' })
          }
          // disabled={transactionsLoading ? true : false}
        >
          Download CSV Report
        </Button>
      </div>

      <br />

      <Report13Table tableData={report13Data?.data || []} />
    </div>
  )
}
